import { useEffect, useState } from 'react';
import { ExternalLink, Play, Film, Wrench, Apple, Newspaper } from 'lucide-react';
import { api } from '../../lib/project';

const GROUP_ICONS = { videos: Film, equipamentos: Wrench, alimentos: Apple, artigos: Newspaper };

const VideoCard = ({ item }) => {
  const [playing, setPlaying] = useState(false);
  return <div className="ref-card ref-video" data-testid={`ref-${item.id}`}>
    {playing
      ? <iframe data-testid={`ref-iframe-${item.id}`} src={`https://www.youtube-nocookie.com/embed/${item.video_id}?autoplay=1&rel=0`} title={item.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      : <button className="ref-thumb" data-testid={`ref-play-${item.id}`} onClick={() => setPlaying(true)} aria-label={`Reproduzir: ${item.title}`}>
          <img src={`https://i.ytimg.com/vi/${item.video_id}/hqdefault.jpg`} alt="" loading="lazy" />
          <span className="ref-play"><Play size={20} fill="currentColor" /></span>
        </button>}
    <div className="ref-meta"><h4>{item.title}</h4><p>{item.author}{item.note ? ` · ${item.note}` : ''}</p></div>
  </div>;
};

const LinkCard = ({ item }) => <a className="ref-card ref-link" data-testid={`ref-${item.id}`} href={item.url} target="_blank" rel="noopener noreferrer">
  <span className="ref-letter" aria-hidden="true">{(item.domain || '?').replace('www.', '')[0].toUpperCase()}</span>
  <div className="ref-meta"><h4>{item.title}</h4>{item.note && <p>{item.note}</p>}<span className="ref-domain">{item.domain} <ExternalLink size={11} /></span></div>
</a>;

export const ReferenceGallery = () => {
  const [data, setData] = useState(null), [error, setError] = useState(false), [loading, setLoading] = useState(true);
  const load = async () => { setLoading(true); setError(false); try { const { data } = await api.get('/references'); setData(data); } catch { setError(true); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  if (loading) return <p className="modal-state" data-testid="references-loading">A carregar as referências…</p>;
  if (error || !data) return <div className="modal-state" data-testid="references-error">Não foi possível carregar as referências.<button data-testid="references-retry-button" onClick={load}>Tentar novamente</button></div>;
  return <div className="ref-gallery" data-testid="reference-gallery">
    {data.groups.map(g => {
      const Icon = GROUP_ICONS[g.id] || Film;
      const videos = g.items.filter(i => i.kind === 'youtube'), links = g.items.filter(i => i.kind !== 'youtube');
      return <section key={g.id} className="ref-group" data-testid={`ref-group-${g.id}`}>
        <header><Icon size={17} strokeWidth={1.6} /><div><h3>{g.title}</h3><p>{g.description}</p></div></header>
        {videos.length > 0 && <div className="ref-video-grid">{videos.map(i => <VideoCard key={i.id} item={i} />)}</div>}
        {links.length > 0 && <div className="ref-link-grid">{links.map(i => <LinkCard key={i.id} item={i} />)}</div>}
      </section>;
    })}
    <p className="tiny-note" data-testid="references-rights-note">{data.note}</p>
  </div>;
};
